import type { TOC } from '@ember/component/template-only';
import { PrismToastQueue, PrismWormhole } from '@mylighthouse/prism-ember';

interface ApplicationSignature {
  Args: {
    controller: unknown;
    model: unknown;
  };
}

<template>
  <div id="ember-basic-dropdown-wormhole"></div>
  <PrismWormhole />

  {{outlet}}

  <PrismToastQueue />
</template> satisfies TOC<ApplicationSignature>;
